import React, { useEffect, useState } from 'react';
// @ts-ignore
import moment, { Moment } from 'moment';
import Calendar from './Calendar';
import { workplaceWorkingHours } from '../../Modules/Workplace/Services/workplace-working-hours.service';
import CalendarWorkplaceOrderingSettingsEventModal from './CalendarWorkplaceOrderingSettingsEventModal';
import { useAppContext } from '../../Services/AppContext';
import LinkButton from '../Button/LinkButton';
import Button from '../Button/Button';
import { Theme } from '../../Enums/Theme.enum';
import ContextMenu from '../ContextMenu/ContextMenu';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import ConfirmationModal from '../../Modules/Base/Components/Confirmation/ConfirmationModal';
import useTranslation from '../../Hooks/useTranslation';
import useCalendarEvent from '../../Modules/Calendar/Hooks/useCalendarEvent';
import ServiceScheduleNotificationModal from '../../Modules/Manager/Components/CaseType/ServiceScheduleNotification/ServiceScheduleNotificationModal';
import OnlineOrdersInstructionsModal from '../../Modules/Manager/Components/OnlineOrders/OnlineOrdersInstructions/OnlineOrdersInstructionsModal';
import { getShouldBeHintDisplayed } from '../../Modules/Manager/Services/manager.service';
import useServiceSchedules from '../../Modules/Workplace/Hooks/useServiceSchedules';
import { getMomentDate } from '../../Utils/dates.util';
import { ServiceScheduleType } from '../../graphql/graphql';
import { CalendarEvent } from '../../Modules/Calendar/Interfaces/CalendarEvent.intefrace';

interface IWorkplaceOrderingSettingsCalendar {
	workplaceId: string;
}

export default function WorkplaceOrderingSettingsCalendar(
	props: IWorkplaceOrderingSettingsCalendar,
) {
	const { t } = useTranslation();

	const { workplaceId } = props;
	const [detailOpened, setDetailOpened] = useState(false);
	const [selectedDate, setSelectedDate] = useState(null);
	const [selectedEvent, setSelectedEvent] = useState<any>(null);
	const [dateRange, setDateRange] = useState({ start: null, end: null });
	const [events, setEvents] = useState([]);
	const [loadingEvents, setLoadingEvents] = useState(false);
	const [businessHours, setBusinessHours] = useState([]);
	const { translation } = useAppContext();
	const { renderOnlineOrderingEvent } = useCalendarEvent();
	const { getWorkplaceSchedules } = useServiceSchedules();
	const [contextMenuProps, setContextMenuProps] = useState({
		isOpen: false,
	});
	const [
		isServiceScheduleNotificationOpen,
		setIsServiceScheduleNotificationOpen,
	] = useState(false);

	const [isInstructionModalOpen, setIsInstructionModalOpen] = useState(true);

	const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
		useState(false);
	const [
		isMultipleDeleteConfirmationOpen,
		setIsMultipleDeleteConfirmationOpen,
	] = useState(false);

	// @ts-ignore
	useEffectAsync(async () => {
		setLoadingEvents(true);
		await handleLoadData();
		await handleLoadWorkingHours();
	}, [dateRange]);

	useEffect(() => {
		setLoadingEvents(false);
	}, [events]);

	const handlePickDate = date => {
		setSelectedDate(date);
		setDetailOpened(true);
	};

	const handleEventClick = event => {
		setSelectedEvent(event);
		setContextMenuProps({
			isOpen: true,
			clientX: event.jsEvent.clientX,
			clientY: event.jsEvent.clientY,
		});
	};

	const handleDateChange = (start: Moment, end?: Moment) => {
		setDateRange({ start, end });
	};

	const handleClose = () => {
		setSelectedEvent(null);
		setDetailOpened(false);
		handleLoadData();
	};

	const handleLoadWorkingHours = () => {
		// @ts-ignore
		new Promise(async () => {
			setBusinessHours(await workplaceWorkingHours({ workplaceId }));
		}).then();
	};

	const handleLoadData = () => {
		if (!dateRange.start) {
			return;
		}

		// @ts-ignore
		const a = async () => {
			const tempEvents: CalendarEvent[] = [];

			const tempEvents2 = await getWorkplaceSchedules({
				from: getMomentDate(dateRange.start),
				to: getMomentDate(dateRange.end || dateRange.start),
				workplaceIds: [workplaceId],
				type: ServiceScheduleType.Shift,
				allDay: true,
			});
			tempEvents2.map(t => tempEvents.push(t));
			const tempEvents3 = await getWorkplaceSchedules({
				from: getMomentDate(dateRange.start),
				to: getMomentDate(dateRange.end || dateRange.start),
				workplaceIds: [workplaceId],
				type: ServiceScheduleType.ShiftExtra,
				allDay: true,
			});
			tempEvents3.map(t => tempEvents.push(t));

			const tempEvents4 = await getWorkplaceSchedules({
				from: getMomentDate(dateRange.start),
				to: getMomentDate(dateRange.end || dateRange.start),
				workplaceIds: [workplaceId],
				type: ServiceScheduleType.OnlineOrder,
			});
			tempEvents4.map(t => tempEvents.push(t));

			setEvents(tempEvents);
		};

		a();
	};

	// @ts-ignore
	const handleRemoveEvent = async (event, excludeFuture = false) => {
		const { repeatable, scheduleId, scheduleItemId } =
			event.event.extendedProps;
		setContextMenuProps({ isOpen: false });

		// @ts-ignore
		const remove = async (obj?: {} = null) => {
			const params = obj ? new URLSearchParams(obj).toString() : '';
			await apiClient.delete(
				`/workplaces/${workplaceId}/services-schedule/${event.event.extendedProps.scheduleId}/items/${event.event.extendedProps.scheduleItemId}?${params}`,
			);
			handleLoadData();
		};

		if (repeatable) {
			const d = moment(event.event.start).toISOString();
			remove({
				excludeDay: d,
				excludeFuture,
			});
		} else {
			remove();
		}
	};

	const handleOpenRemoveSingle = () => {
		setContextMenuProps({ isOpen: false });
		setIsDeleteConfirmationOpen(true);
	};

	const handleOpenRemoveMultiple = () => {
		setContextMenuProps({ isOpen: false });
		setIsMultipleDeleteConfirmationOpen(true);
	};

	const handleRemoveSingle = async () => {
		await handleRemoveEvent(selectedEvent);
		setSelectedEvent(null);
		setIsDeleteConfirmationOpen(false);
		setIsMultipleDeleteConfirmationOpen(false);
	};

	const handleRemoveMultiple = async () => {
		await handleRemoveEvent(selectedEvent, true);
		setSelectedEvent(null);
		setIsMultipleDeleteConfirmationOpen(false);
	};

	const handleOnSuccess = () => {
		handleClose();
		setIsServiceScheduleNotificationOpen(true);
	};

	const handleCreateNewEvent = (date: Moment) => {
		setContextMenuProps({ isOpen: false });
		setSelectedEvent(null);
		handlePickDate(date);
	};

	const handleDeleteFromDetail = () => {
		setDetailOpened(false);
		if (selectedEvent?.event?.extendedProps?.repeatable) {
			handleOpenRemoveMultiple();
		} else {
			handleOpenRemoveSingle();
		}
	};

	return (
		<>
			<Calendar
				events={events}
				onTimeClick={handlePickDate}
				onEventClick={handleEventClick}
				initialView={'timeGridWeek'}
				onDateChange={handleDateChange}
				allDaySlot={true}
				businessHours={businessHours}
				editable={true}
				loadingEvents={loadingEvents}
				renderEventItem={renderOnlineOrderingEvent}
			/>
			<ContextMenu
				params={contextMenuProps}
				onContextClose={() => setContextMenuProps({ isOpen: false })}>
				<LinkButton
					onClick={() => {
						setDetailOpened(true);
						setContextMenuProps({ isOpen: false });
					}}
					title={'base.shared.edit'}
					theme={Theme.BLUE}
					firstUpper
				/>
				<LinkButton
					onClick={() => handleCreateNewEvent(selectedEvent?.event?.start)}
					title={
						'component.workplaceOrderingSettingsCalendar.createNewSettings'
					}
					theme={Theme.BLUE}
					firstUpper
				/>
				<div style={{ marginTop: '20px' }} />
				{selectedEvent?.event?.extendedProps?.repeatable ? (
					<LinkButton
						theme={Theme.RED}
						title='base.deleteSetup'
						onClick={handleOpenRemoveMultiple}
						firstUpper
					/>
				) : (
					<LinkButton
						theme={Theme.RED}
						title='base.deleteSetup'
						onClick={handleOpenRemoveSingle}
						firstUpper
					/>
				)}
			</ContextMenu>
			<CalendarWorkplaceOrderingSettingsEventModal
				opened={detailOpened}
				onClose={handleClose}
				selectedDate={selectedDate}
				defaultData={selectedEvent}
				workplaceId={workplaceId}
				onSuccess={handleOnSuccess}
				onDelete={handleDeleteFromDetail}
			/>
			<ConfirmationModal
				title='component.onlineOrdering.deleteSetup'
				text={
					t(
						'component.onlineOrdering.deleteMultipleSetupConfirmationMessage',
					) ?? ''
				}
				isOpen={isMultipleDeleteConfirmationOpen}
				onClose={() => setIsMultipleDeleteConfirmationOpen(false)}>
				<div className='d-flex flex-row' style={{ gap: '15px' }}>
					<Button
						onClick={handleRemoveSingle}
						title={'base.deleteOnlyThisOne'}
						theme={Theme.GREEN}
					/>
					<Button
						onClick={handleRemoveMultiple}
						title={'base.deleleAlsoFutures'}
						theme={Theme.BLUE}
					/>
				</div>
			</ConfirmationModal>
			<ConfirmationModal
				title='base.deleteSetup'
				text={
					t('component.onlineOrdering.deleteSetupConfirmationMessage') ?? ''
				}
				isOpen={isDeleteConfirmationOpen}
				onClose={() => setIsDeleteConfirmationOpen(false)}>
				<Button
					onClick={handleRemoveSingle}
					title={'base.shared.delete'}
					theme={Theme.GREEN}
				/>
			</ConfirmationModal>
			{isServiceScheduleNotificationOpen &&
				getShouldBeHintDisplayed(
					'doNoShowServiceScheduleNotificationModal',
				) && (
					<ServiceScheduleNotificationModal
						isOpened={isServiceScheduleNotificationOpen}
						beforeRedirect={() => setIsServiceScheduleNotificationOpen(false)}
						onClose={() => setIsServiceScheduleNotificationOpen(false)}
					/>
				)}
			{isInstructionModalOpen &&
				getShouldBeHintDisplayed('doNoShowOnlineOrdersInstructionsModal') && (
					<OnlineOrdersInstructionsModal
						isOpened={isInstructionModalOpen}
						onClose={() => setIsInstructionModalOpen(false)}
					/>
				)}
		</>
	);
}
